// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"667":"43a4d487","977":"7daf220f"}[chunkId] + ".chunk.js");